// I16 path C — client-side thumbnail/medium URL derivation. Mirrors
// `r2t_url` in apps/api/src/pieces/variants.rs: rewrites
// `<scheme>://<host>/r2/<key>` → `<scheme>://<host>/r2t/<w>/<key>`.
//
// Used for live WS-added pieces (whose frames carry only `image_url`)
// and as a fallback when the `/pieces` wire lacks thumb fields. The
// server wire is the source of truth; this helper just matches it.

/** Mural tile width (px, longest side). */
export const THUMB_W = 256;
/** Click-zoom lightbox width (px, longest side). */
export const MEDIUM_W = 1024;

export function r2tUrl(imageUrl: string, width: number): string {
  const i = imageUrl.indexOf("/r2/");
  if (i < 0) return imageUrl;
  const key = imageUrl.slice(i + "/r2/".length);
  if (!key || key.includes("..")) return imageUrl;
  return `${imageUrl.slice(0, i)}/r2t/${width}/${key}`;
}

/** Thumbnail URL for mural tiles (256 box). Falls back to the original. */
export function thumbFor(imageUrl: string): string {
  return r2tUrl(imageUrl, THUMB_W);
}

/** Medium URL for the click-zoom lightbox (1024 box). Falls back to original. */
export function mediumFor(imageUrl: string): string {
  return r2tUrl(imageUrl, MEDIUM_W);
}
